import { CubeIcon } from "@phosphor-icons/react";

export function EmptyState({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="empty-state">
      <span className="empty-state__icon">
        <CubeIcon size={22} weight="regular" />
      </span>
      <strong>{title}</strong>
      <p>{description}</p>
    </div>
  );
}
